<script>
    import { getContext } from 'svelte';
    import PublishNote from './popups/PublishNote/container.svelte';
    import PublishNoteForm from './popups/PublishNote/content.svelte';
    export let postUid;
    export let slug;
    export let isPublished;
  
    const { open, close } = getContext('simple-modal');
    const showPopup = () => {
          open(PublishNote,
            {
                message: slug ? 'Published note' : "Publish note",
            },
            {
                form: PublishNoteForm,
                propsForForm: [postUid, slug, isPublished],
            }
        );
      };
</script>

<button 
    class="primary-green" 
    on:click={showPopup}>
        publish
</button>